import { render, staticRenderFns } from "./AddOrEditCompanyByForm.vue?vue&type=template&id=91fb7850"
import script from "./AddOrEditCompanyByForm.vue?vue&type=script&lang=ts"
export * from "./AddOrEditCompanyByForm.vue?vue&type=script&lang=ts"
import style0 from "./AddOrEditCompanyByForm.vue?vue&type=style&index=0&id=91fb7850&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports